import React, { useEffect, useRef, useState } from "react";
import { ShootingsDTO } from "../../interfaces/ShootingsDTO";
import { AthleteDTO } from "../../interfaces/AthletesDTO";
import ShootingTarget from "./ShootingTarget";
import { TimeEvent, eventBus } from "../../services/eventHandler";
import { ShootingLiveDTO } from "../../interfaces/ShootingLiveDTO";
import { RaceDTO } from "../../interfaces/RaceDTO";

interface Props {
  shooter: ShootingLiveDTO | null;
  race: RaceDTO;
  lane: number;
}

const ShootingRow = ({ shooter, race, lane }: Props) => {
  let timeoutId; // Variable to store timeout ID

  const [ath,setAth] = useState<AthleteDTO | null>(null);
  const [shoot,setShoot] = useState<ShootingLiveDTO | null>(shooter);
  const [miss,setMiss] = useState<boolean>(false);
  const athRef = useRef<AthleteDTO | null>(null);

  useEffect(() => {
    athRef.current = ath;
  }, [ath])

  useEffect(() => {
    const handlerShooting = (_shoot:TimeEvent) =>{
      if (_shoot.messageType === "shootLive"){
        setShoot(_shoot.shooting == undefined ? null : _shoot.shooting);
        if (!(_shoot.shooting == undefined || _shoot.shooting == null) ){
          let update = false;
          if (ath == null){
            update = true;
          }
          else if (ath.Startno !== _shoot.shooting.Startno){
            update = true;
          }
          if (update){
            let athl = race.Class[_shoot.shooting.ClassID].Level[_shoot.shooting.Level].Athletes[_shoot.shooting.Startno];
            setAth(athl);
          }
         
        }
        
      }
      else if (_shoot.messageType === "shootStatus"){
          if (_shoot.status === "MISS"){
            handleMiss();
          }
          else if (_shoot.status === "OUT"){
            // const currentShoot = shoot;
            const currentAth = ath;
  
            // Set timeout
            timeoutId = setTimeout(() => {
              // Check if values are unchanged before setting to null
              if(!currentAth || !athRef.current){
                setShoot(null);
                setAth(null);
              }
              else if (currentAth.Startno !== athRef.current.Startno) {
                setShoot(null);
                setAth(null);
              }
            }, 5000);
  
          }
      }
      
    };

if (shooter !== null){
  let athl = race.Class[shooter.ClassID].Level[shooter.Level].Athletes[shooter.Startno];
setAth(athl);
}

    eventBus.on(
      `shooting_${lane}`,
      handlerShooting
    );
    return () => {      
      // Cleanup to avoid memory leaks
      eventBus.removeListener(
        `shooting_${lane}`,
        handlerShooting
      );
    };
  },[])

  const handleMiss =() => {
    setMiss(true);
    const timeoutId = setTimeout(() => {
      setMiss(false);
    }, (2000) );
    // Clear the timeout when the component is unmounted
    return () => clearTimeout(timeoutId);
  };
  

  return (
    <div className="shooting-row" data-bib={ath == null ? null: ath.Startno} data-athleteid={ath == null ? null: ath.ID}>
      <div className="shooting-row-data shooting-bib">
        <span>{ath == null ? <>&nbsp;</> : ath.Startno}</span>
      </div>
      <div className="shooting-row-data shooting-name">
        <span>{ath == null ? <>&nbsp;</> : ath.FormatedName}</span>
      </div>
      <div className="shooting-row-data shooting-short-name">
        <span>{ath == null ? <>&nbsp;</> : ath.FormatedName}</span>
      </div>
      <div className="shooting-row-data shooting-flag">
        <span>&nbsp;</span>
      </div>
      <div className="shooting-row-data shooting-team">
        <span>{ath == null ? <>&nbsp;</> : ath.Club}</span>
      </div>
      <ShootingTarget miss={miss} lanenumber={lane} shootingstring={shoot == null ? "00000" : shoot.ShootingString} />

    </div>
  );
};

export default ShootingRow;
